<template>
  <v-container fluid class="asset-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Asset Information</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Asset</p>
                        <v-text-field
                          class="mb-4"
                          v-model="asset.assetcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Asset Code"
                          persistent-hint
                          single-line hint="Enter the asset Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="asset.assetname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Asset Name"
                          persistent-hint
                          single-line hint="Enter the asset name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="asset.assetpage"
                          outlined
                          dense
                          placeholder="Asset Page"
                          persistent-hint
                          single-line hint="Enter the asset page">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="asset.assettype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the asset type">
                        </v-select>
                          <v-switch
                            v-model="asset.assetstatus"
                            color="primary"
                            v-bind:label="asset.assetstatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/asset/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createAsset()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      asset: {
        assetstatus: 'Active'
      },
      items: ['Image', 'List', 'Video'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Asset', ['createAssetRequest', 'getAssetsRequest']),
    checkError(){
      if(!this.asset.assetcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.asset.assetname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.asset.assettype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async createAsset() {
      if(!this.checkError()) return;
      await this.createAssetRequest(this.asset);
      this.getAssetsRequest();
      router.push('/asset/list');
    },
  },
  computed: {
    ...mapState('Asset', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
